/**
 * @file メニューの中に置く見た目の切り替え (自動 / ライト / ダーク)。
 *
 * @what: 3つのボタンを横に並べ、選んでいるものに aria-checked を付ける。押しても
 *   メニューは閉じない (切り替えの結果をその場で見せる)。
 * @why: ダークは /study の面にだけ効くので、入口もスタディを開いているときだけ出す
 *   (呼び出し側の Layout が出し分ける)。
 * @failure: 描画のみ。保存と適用は shared/ui/theme.ts が受け持つ。
 */

import type { ThemeMode } from "./theme";

const OPTIONS: { value: ThemeMode; label: string }[] = [
  { value: "system", label: "自動" },
  { value: "light", label: "ライト" },
  { value: "dark", label: "ダーク" },
];

export function ThemeSwitch({
  mode,
  onChange,
}: {
  mode: ThemeMode;
  onChange: (next: ThemeMode) => void;
}) {
  return (
    <div className="app-menu-theme">
      <span className="app-menu-theme-label" id="app-menu-theme-label">
        見た目
      </span>
      <div className="app-menu-theme-choices" role="group" aria-labelledby="app-menu-theme-label">
        {OPTIONS.map((o) => (
          <button
            key={o.value}
            type="button"
            role="menuitemradio"
            aria-checked={mode === o.value}
            className="app-menu-theme-btn"
            onClick={() => onChange(o.value)}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
